import { LocationType } from '../enums/shared-enums.enum';
import { Injectable } from '@angular/core';
import { BaseAPI } from '@core/services/base-api.service';
import { Mapper } from '@core/services/base-mapper.service';
import { APIConstants } from '@shared/constants';
import { filterNullEntity } from '@shared/utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocationModel } from '../../customers/models/location.model';
import { WCCRegion } from '@features/shipment-creation-template/models/wcc-region.model';
import { WCCReceiver } from '@features/shipment-creation-template/models/wcc-receiver.model';

@Injectable({
  providedIn: 'root',
})
export class LocationAPI {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  addLocation(
    location: LocationModel,
    id: number,
    usersIds?: number[],
    defaultUserId?: number
  ): Observable<LocationModel> {
    const body = filterNullEntity({
      type: location.type,
      id: id,
      title: location.title,
      gates: location.gates,
      address: location.address,
      cityId: location.cityId,
      latitude: location.latitude,
      longitude: location.longitude,
      shippingType: location.shippingType,
      usersIds: usersIds,
      defaultUserId: defaultUserId,
      wccRegionId: location?.wccRegion?.id,
      wccReceiverId: location?.wccReceiver?.id,
    });

    return this.baseAPI.post(APIConstants.API_ADD_LOCATION, body).pipe(
      map((res) => {
        return this.mapper.fromJson(LocationModel, res.data);
      })
    );
  }
  editLocation(location: Partial<LocationModel>, id?: number): Observable<LocationModel> {
    return this.baseAPI
      .put(APIConstants.API_EDIT_LOCATION, { ...location, customerId: id })
      .pipe(
        map((res) => {
          return this.mapper.fromJson(LocationModel, res.data);
        })
      );
  }

  getLocations(locationType: LocationType, id: number = 0): Observable<LocationModel[]> {
    return this.baseAPI
      .get(APIConstants.API_LOCATION_GET_ALL + `?type=${locationType}&id=${id}`)
      .pipe(
        map((res) => {
          return this.mapper.fromJson(LocationModel, res.data);
        })
      );
  }

  getWCCRegions(id: number): Observable<WCCRegion[]> {
    return this.baseAPI.get(APIConstants.API_GET_WCC_REGIONS + `/${id}`).pipe(
      map((res) => {
        return this.mapper.fromJson(WCCRegion, res.data);
      })
    );
  }

  getWCCReceivers(regionId: number, customerId: number): Observable<WCCReceiver[]> {
    return this.baseAPI.get(APIConstants.API_GET_WCC_RECEIVERS + `/${regionId}/${customerId}`).pipe(
      map((res) => {
        return this.mapper.fromJson(WCCReceiver, res.data);
      })
    );
  }

  getLocation(locationId: number, ownerId?: number): Observable<LocationModel> {
    return this.baseAPI
      .get(`${APIConstants.GET_LOCATION_DETAILS}/${locationId}`)
      .pipe(map((res) => this.mapper.fromJson(LocationModel, res.data)));
  }
}
